'use client'

import { type FC } from 'react'

import { AudioBars } from './variants/audio-bars'
import { AudioButton } from './variants/audio-button'
import { AudioCard } from './variants/audio-card'

interface AudioProps {
  url: string
  variant: 'button' | 'card' | 'bars'
  title?: string
  group?: string
  compact?: boolean
  /** bars only: 'dark' styles the player for a navy ground. */
  tone?: 'light' | 'dark'
  className?: string
}

export const Audio: FC<AudioProps> = ({ url, variant, title, group, compact, tone, className }) => {
  if (!url) return null

  switch (variant) {
    case 'button':
      return <AudioButton url={url} group={group} className={className} />
    case 'card':
      return <AudioCard url={url} title={title} group={group} className={className} />
    case 'bars':
      return <AudioBars url={url} title={title} group={group} compact={compact} tone={tone} className={className} />
  }
}
